import { render, staticRenderFns } from "./TabProminent.vue?vue&type=template&id=17c9a705&"
import script from "./TabProminent.vue?vue&type=script&lang=js&"
export * from "./TabProminent.vue?vue&type=script&lang=js&"
import style0 from "./TabProminent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c9a705')) {
      api.createRecord('17c9a705', component.options)
    } else {
      api.reload('17c9a705', component.options)
    }
    module.hot.accept("./TabProminent.vue?vue&type=template&id=17c9a705&", function () {
      api.rerender('17c9a705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabProminent.vue"
export default component.exports